import { WebhookPayload } from "../websocket/websocket.service";
import { AppNotification } from "./notificacoes.service";

export enum NotificationType {
  ATENDIMENTO_TRANSFERIDO = "ATENDIMENTO_TRANSFERIDO",
  ATENDIMENTO_FINALIZADO = "ATENDIMENTO_FINALIZADO",
  SINCRONIZACAO_CONTATOS_CONCLUIDA = "SINCRONIZACAO_CONTATOS_CONCLUIDA",
  IMPORTACAO_CONTATOS_CONCLUIDA = "IMPORTACAO_CONTATOS_CONCLUIDA",
  EXPORTACAO_CONVERSAS_CONCLUIDA = "EXPORTACAO_CONVERSAS_CONCLUIDA",
  EXPORTACAO_CONVERSAS_ERRO = "EXPORTACAO_CONVERSAS_ERRO",
}

// Payload que chega pelo socket em NOTIFICACAO.NOVA
export type NotificacaoNovaPayload = WebhookPayload & AppNotification;
